import { render, staticRenderFns } from "./ChannelId.vue?vue&type=template&id=fc456820&scoped=true"
import script from "./ChannelId.vue?vue&type=script&lang=js"
export * from "./ChannelId.vue?vue&type=script&lang=js"
import style0 from "./ChannelId.vue?vue&type=style&index=0&id=fc456820&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc456820",
  null
  
)

export default component.exports